/**
 * Mailer Template List - Column & filter configuration
 */
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import {
    createColumns,
    createDateFormatter,
} from '@/components/ui/data-table-customized'
import type { MailerTemplate } from '../types'
import type { TFunction } from 'i18next'
import { Link } from 'react-router-dom'
import { generatePathDatacentral, paths } from '@/utils/path'
import { MAILER_TEMPLATE_TYPE_CHIP_COLOR_MAP } from './mailer-template-types'

// ============================================================================
// Columns
// ============================================================================

export const getMailerTemplateColumns = (
    t: TFunction
): DataTableColumn<MailerTemplate>[] =>
    createColumns<MailerTemplate>([
        {
            key: 'mailer_template_id',
            title: 'ID',
            width: 80,
            sortable: false,
            render: (_, row) => (
                <Link
                    to={generatePathDatacentral(paths.mailerTemplateDetail, {
                        id: row.mailer_template_id,
                    })}
                    className="text-primary hover:underline"
                >
                    {row.mailer_template_id}
                </Link>
            ),
        },
        {
            key: 'mailer_template_subject',
            title: t('mailerCampaign:template_subject'),
            sortable: false,
        },
        {
            key: 'mailer_template_type',
            title: t('type'),
            formatter: {
                type: 'chip',
                colorMap: MAILER_TEMPLATE_TYPE_CHIP_COLOR_MAP,
            },
        },
        {
            key: 'mailer_template_variables',
            title: t('mailerCampaign:variables'),
            render: (_value, row) => (
                <span>{row.mailer_template_variables?.length ?? 0}</span>
            ),
        },
        {
            key: 'mailer_template_created_at',
            title: t('created_at'),
            formatter: createDateFormatter({ format: 'DD/MM/YYYY HH:mm' }),
        },
        {
            key: 'mailer_template_updated_at',
            title: t('updated_at'),
            formatter: createDateFormatter({ format: 'DD/MM/YYYY HH:mm' }),
        },
    ])

// ============================================================================
// Sort & filter configuration
// ============================================================================

export const MAILER_TEMPLATE_SORT_CONFIG = {
    defaultSort: {
        sort_by: 'mailer_template_id',
        sort_order: 'desc' as const,
    },
}

export const MAILER_TEMPLATE_FILTER_DEFAULTS = {
    q: '',
}
